import { FormItem, TextAnswerFormat } from "../../../types/Survey";

const allowedAnswerFormats = ["NumericAnswerFormat", "ValuePickerAnswerFormat", "DateAnswerFormat", "TimeOfDayAnswerFormat", "FileAnswerFormat", "PhoneAnswerFormat", "EmailAnswerFormat", "PostalCodeAnswerFormat", "DateOfBirthAnswerFormat"];
export function canCustomizeTextPosition(formItem: FormItem): boolean {
    if (formItem.answerFormat?.type === "TextAnswerFormat") {
        return !(formItem.answerFormat as TextAnswerFormat).multipleLines;
    }

    return !!formItem.answerFormat && allowedAnswerFormats.includes(formItem.answerFormat.type);
}

export function canBeInHorizontalLayout(formItem: FormItem): boolean {
    return formItem.textPosition === "top" && canCustomizeTextPosition(formItem);
}